import { catchError, EMPTY, take } from 'rxjs';

import { FeatureFlagService } from './feature-flag.service';

/**
 * @AURA - Defer loading until aura ff was checked
 * USED IN rs-frontend:app.module.ts
 * @param featureFlagService
 * @param config
 * @returns
 */
export function featureFlagInitializerFactory(
  featureFlagService: FeatureFlagService
) {
  return (): Promise<void> =>
    new Promise((resolve) => {
      featureFlagService
        .load()
        .pipe(
          take(1),
          catchError(() => EMPTY)
        )
        .subscribe(() => {
          resolve();
        });
    });
}
